import { color, font, query, space } from '@design/templateFns';
import styled from 'styled-components';

/*** MODAL */

export const ModalHeader = styled.h3`
  ${font('headline-xxs')};
  padding: 0;

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-xs')}
  }
`;

export const ModalText = styled.div`
  margin-top: ${space('x6')};

  @media screen and (${query.atLeast('desktop')}) {
    margin-top: ${space('x7')};
  }

  p {
    ${font('body-sm-light')};
    padding: 0;
    margin-bottom: ${space('lg')};

    @media screen and (${query.atLeast('desktop')}) {
      ${font('body-md-light')};
    }
  }

  ul {
    list-style: disc;
    ${font('body-sm-light')};
    padding-left: ${space('x5')};
    margin-bottom: ${space('x6')};

    @media screen and (${query.atLeast('desktop')}) {
      ${font('body-md-light')};
      margin-bottom: ${space('x7')};
    }
  }
`;

export const TopDefault = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${space('x6')} ${space('xl')};

  @media screen and (${query.atLeast('tablet')}) {
    padding: ${space('x6')} ${space('x8')};
  }

  button {
    margin-left: auto;
    cursor: pointer;
  }
`;

export const SearchInput = styled.input<{ $isError: boolean }>`
  background-color: rgba(255, 255, 255, 0.95);
  font-size: 16px;
  padding: ${space('sm')} ${space('md')};
  border: 1px solid ${({ $isError }) => ($isError ? color('cta') : color('gray2'))};
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;
  &:focus {
    outline: none;
    box-shadow: none !important;
  }
  &:focus::placeholder {
    color: transparent;
  }
  @media screen and (${query.atLeast('tablet')}) {
    &:focus {
      box-shadow: 0 0 0 3px hsl(220deg 100% 50% / 80%);
    }
  }
`;

export const EmailField = styled(SearchInput)`
  ${font('body-sm')};

  @media screen and (min-width: 600px) {
    font-size: 16px;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 225px;
  margin: ${space('x8')} auto 0;
  position: relative;
  height: 225px;

  @media screen and (${query.below('tablet')}) {
    margin-top: ${space('x10')};
  }
`;

export const SVGWrapper = styled.div`
  width: 100%;
  max-width: 132px;
  margin: 0 auto ${space('x8')};

  @media screen and (${query.below('tablet')}) {
    margin-bottom: ${space('x10')};
  }

  svg {
    width: 100%;
    height: auto;
  }
`;

export const ModalButtonWrapperFixed = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  box-shadow: 0px 1px 41px rgba(0, 0, 0, 0.1);
  padding: ${space('x8')};
  position: relative;

  @media screen and (${query.below('tablet')}) {
    padding: ${space('xl')};
  }
`;

export const ModalButtonWrapper = styled.div`
  width: 100%;
  justify-content: center;
  flex-direction: column;
  display: flex;
  box-sizing: border-box;

  button {
    border-radius: 4px;
    width: 100%;
  }
`;
export const ErrorLabel = styled.label`
  ${font('body-sm')};
  color: ${color('cta')};
  width: 100%;
  padding-bottom: 2px;
  margin-top: -10px;
  display: inline-flex;
  line-height: 25px;
  margin-top: 8px;
  svg {
    fill: ${color('cta')};
    margin-top: 3px;
    margin-right: 4px;
  }
  @media screen and (${query.below('tablet')}) {
    ${font('body-sm')};
  }
`;
export const ErrorIcon = styled.div`
  color: ${color('cta')};
  width: 15px;
  height: 15px;
  border: 1px solid ${color('cta')};
  border-radius: 50%;
  display: inline;
  position: relative;
  top: 4px;
  margin-right: 5px;
    span {
      font-size: 11px;
      position: relative;
      top: -5px;
      padding: 6px;
    }
    @media screen and (${query.below('tablet')}){
      top: 2px;
    }
  }
`;

/*** SUCESS SECTION */
export const SuccessWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: inherit;
  height: calc(100% - 108px); // minus Button Section height
`;

export const SuccessText = styled(ModalText)`
  ${font('body-sm-light')};
  text-align: center;
  max-width: 272px;
  margin-top: ${space('xl')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md-light')};
    margin-top: ${space('lg')};
  }
`;

export const ModalInner = styled.div`
  background: ${color('bg')};
  padding: 0 ${space('xl')};
  position: relative;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
  height: 100%;

  @media screen and (${query.atLeast('tablet')}) {
    padding: 0 ${space('x8')};
  }
`;
